import { useQuery } from '@tanstack/react-query';

import { getAchievement } from '~/services/AgentHub/AgentService';

import { achievementQueryKeys } from './useListAchievements';

export function useGetAchievement(id?: string) {
  return useQuery({
    queryKey: achievementQueryKeys.detail(id ?? ''),
    queryFn: async () => {
      return await getAchievement(id ?? '');
    },
    enabled: !!id,
  });
}
